export function clearSessionStorage() {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('2fauthenticated');
}

export function performSessionLogout() {
  clearSessionStorage();
  window.location.href = '/home';
}
